import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const InsightsContainer = styled.div<{ theme: { token: GlobalToken } }>`
  h1 {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
  }

  .display-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .beta-tag {
    margin-right: ${({ theme: { token } }) => token.marginXXS}px;
  }

  .insights-card {
    padding: ${({ theme: { token } }) => token.padding}px;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .insights-card-wrapper {
    position: relative;
  }

  .ant-tabs {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;

    .ant-tabs-content-holder {
      flex: 1;
      min-height: 0;
      overflow: hidden;
    }

    .ant-tabs-content {
      height: 100%;
      overflow: hidden;
    }

    .ant-tabs-tabpane {
      height: 100%;
      overflow: auto;
    }

    .ant-tabs-nav {
      margin: 0;
      flex-shrink: 0;

      .ant-tabs-nav-wrap {
        display: flex;
        justify-content: center;
        margin-left: ${({ theme: { token } }) => token.marginXXS}px;

        .ant-tabs-tab {
          padding: 0 ${({ theme: { token } }) => token.paddingXS}px;
          margin: 0 ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.paddingXXS}px
            ${({ theme: { token } }) => token.paddingXS}px;
          flex-grow: 0;
        }

        .ant-tabs-ink-bar {
          background-color: ${({ theme: { token } }) => token.colorPrimary};
          height: 3px;
          border-radius: 5px 5px 0 0;
        }
      }
    }
  }

  .insights-card-footer {
    margin-top: ${({ theme: { token } }) => token.marginMD}px;
    padding-top: ${({ theme: { token } }) => token.paddingMD}px;
    border-top: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    flex-shrink: 0;

    .periodic-report-card {
      display: flex;
      align-items: center;
      padding: ${({ theme: { token } }) => token.paddingMD}px;
      background: ${({ theme: { token } }) => token.colorBgElevated || '#1a2332'};
      border: 1px solid ${({ theme: { token } }) => token.colorPrimary || '#22BBE8'};
      border-radius: ${({ theme: { token } }) => token.borderRadiusLG || 8}px;
      gap: ${({ theme: { token } }) => token.marginMD}px;

      .periodic-report-icon {
        flex-shrink: 0;
      }

      .periodic-report-content {
        display: flex;
        flex-direction: column;
        gap: ${({ theme: { token } }) => token.marginXXS}px;
        flex: 1;
        margin: 0;

        .periodic-report-title {
          font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
          font-weight: ${({ theme: { token } }) => token.fontWeightStrong || 600};
          color: ${({ theme: { token } }) => token.colorText};
          margin: 0;
        }

        .periodic-report-details {
          display: flex;
          align-items: center;
          gap: ${({ theme: { token } }) => token.marginXS}px;
          font-size: ${({ theme: { token } }) => token.fontSize}px;
          color: ${({ theme: { token } }) => token.colorText};
          flex-wrap: wrap;
          margin: 0;
        }

        .periodic-report-separator {
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: ${({ theme: { token } }) => token.colorTextSecondary};
        }

        .periodic-report-value {
          padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingSM}px;
          background: ${({ theme: { token } }) => token.colorBgContainer || '#0f1624'};
          border-radius: ${({ theme: { token } }) => token.borderRadius || 12}px;
          color: ${({ theme: { token } }) => token.colorText};
          font-weight: ${({ theme: { token } }) => token.fontWeightStrong || 600};
        }
      }

      .periodic-report-view-button {
        background: none;
        border: none;
        padding: 0;
        color: ${({ theme: { token } }) => token.colorPrimary || '#22BBE8'};
        font-size: ${({ theme: { token } }) => token.fontSize}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong || 500};
        cursor: pointer;
        flex-shrink: 0;
        transition: opacity 0.2s;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
`;
